const ArticlesIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.79688"
      y="2.93848"
      width="10.1738"
      height="6.90867"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M1.60156 1.73926L2.38416 1.73926L2.38416 0.724107C2.38416 0.599517 2.20897 0.498518 1.99286 0.498518C1.77675 0.498518 1.60156 0.599517 1.60156 0.724107L1.60156 1.73926Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="1.99286"
      cy="1.73632"
      rx="0.225589"
      ry="0.391301"
      transform="rotate(-90 1.99286 1.73632)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.55786 2.18573C3.55531 1.68863 2.85552 1.28611 1.99266 1.28611C1.12823 1.28611 0.427461 1.69011 0.427461 2.18846C0.427461 2.19774 0.427704 2.20699 0.428186 2.21619L0.428186 2.81738L0.870261 2.81738C1.15465 2.98604 1.55243 3.09082 1.99266 3.09082C2.43289 3.09082 2.83068 2.98604 3.11507 2.81738L3.55859 2.81738L3.55859 2.18573L3.55786 2.18573Z"
      fill="white"
    />
    <path
      d="M1.99266 1.28611L1.99266 1.63611L1.99266 1.28611ZM3.55786 2.18573L3.20787 2.18753C3.20886 2.38013 3.36526 2.53573 3.55786 2.53573L3.55786 2.18573ZM0.428186 2.21619L0.778186 2.21619C0.778186 2.21009 0.778026 2.20399 0.777707 2.1979L0.428186 2.21619ZM0.428186 2.81738L0.0781858 2.81738C0.0781858 2.91021 0.115061 2.99923 0.180698 3.06487C0.246336 3.13051 0.33536 3.16738 0.428186 3.16738L0.428186 2.81738ZM0.870261 2.81738L1.04879 2.51634C0.994756 2.48429 0.933088 2.46738 0.870261 2.46738L0.870261 2.81738ZM3.11507 2.81738L3.11507 2.46738C3.05224 2.46738 2.99057 2.48429 2.93654 2.51634L3.11507 2.81738ZM3.55859 2.81738L3.55859 3.16738C3.75189 3.16738 3.90859 3.01068 3.90859 2.81738L3.55859 2.81738ZM3.55859 2.18573L3.90859 2.18573C3.90859 1.99243 3.75189 1.83573 3.55859 1.83573L3.55859 2.18573ZM1.99266 1.63611C2.37402 1.63611 2.70228 1.72579 2.92343 1.85294C3.15395 1.98546 3.2075 2.1165 3.20787 2.18753L3.90786 2.18393C3.90567 1.75786 3.60805 1.43909 3.27232 1.24608C2.92723 1.04768 2.47416 0.936108 1.99266 0.936108L1.99266 1.63611ZM0.777461 2.18846C0.777461 2.11752 0.830242 1.98649 1.06071 1.85362C1.28185 1.72613 1.61058 1.63611 1.99266 1.63611L1.99266 0.936108C1.51031 0.936107 1.05644 1.04808 0.711089 1.24718C0.375062 1.44091 0.0774607 1.76105 0.0774607 2.18846L0.777461 2.18846ZM0.777707 2.1979C0.777544 2.19477 0.777461 2.19163 0.777461 2.18846L0.0774607 2.18846C0.0774607 2.20385 0.0778637 2.2192 0.0786643 2.23449L0.777707 2.1979ZM0.778186 2.81738L0.778186 2.21619L0.0781858 2.21619L0.0781858 2.81738L0.778186 2.81738ZM0.870261 2.46738L0.428186 2.46738L0.428186 3.16738L0.870261 3.16738L0.870261 2.46738ZM1.99266 2.74082C1.60324 2.74082 1.26967 2.64733 1.04879 2.51634L0.691728 3.11842C1.03963 3.32475 1.50162 3.44082 1.99266 3.44082L1.99266 2.74082ZM2.93654 2.51634C2.71566 2.64733 2.38208 2.74082 1.99266 2.74082L1.99266 3.44082C2.4837 3.44082 2.94569 3.32475 3.2936 3.11842L2.93654 2.51634ZM3.55859 2.46738L3.11507 2.46738L3.11507 3.16738L3.55859 3.16738L3.55859 2.46738ZM3.20859 2.18573L3.20859 2.81738L3.90859 2.81738L3.90859 2.18573L3.20859 2.18573ZM3.55786 2.53573L3.55859 2.53573L3.55859 1.83573L3.55786 1.83573L3.55786 2.53573Z"
      fill="#212121"
    />
    <ellipse
      cx="1.99489"
      cy="2.84081"
      rx="0.902356"
      ry="1.5652"
      transform="rotate(-90 1.99489 2.84081)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M0.625 10.3369L3.36411 10.3369L3.36411 2.63868C3.36411 2.20262 2.75094 1.84912 1.99455 1.84912C1.23817 1.84912 0.625 2.20262 0.625 2.63868L0.625 10.3369Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="1.99455"
      cy="10.3325"
      rx="0.789562"
      ry="1.36955"
      transform="rotate(-90 1.99455 10.3325)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.55786 10.3498C3.55531 9.85269 2.85552 9.45017 1.99266 9.45017C1.12823 9.45017 0.427461 9.85417 0.427461 10.3525C0.427461 10.3618 0.427704 10.371 0.428186 10.3803L0.428186 10.9814L0.870261 10.9814C1.15465 11.1501 1.55243 11.2549 1.99266 11.2549C2.43289 11.2549 2.83068 11.1501 3.11507 10.9814L3.55859 10.9814L3.55859 10.3498L3.55786 10.3498Z"
      fill="white"
    />
    <path
      d="M1.99266 9.45017L1.99266 9.80017L1.99266 9.45017ZM3.55786 10.3498L3.20787 10.3516C3.20886 10.5442 3.36526 10.6998 3.55786 10.6998L3.55786 10.3498ZM0.428186 10.3803L0.778186 10.3803C0.778186 10.3742 0.778026 10.3681 0.777707 10.362L0.428186 10.3803ZM0.428186 10.9814L0.0781858 10.9814C0.0781858 11.0743 0.115061 11.1633 0.180698 11.2289C0.246336 11.2946 0.33536 11.3314 0.428186 11.3314L0.428186 10.9814ZM0.870261 10.9814L1.04879 10.6804C0.994756 10.6484 0.933088 10.6314 0.870261 10.6314L0.870261 10.9814ZM3.11507 10.9814L3.11507 10.6314C3.05224 10.6314 2.99057 10.6484 2.93654 10.6804L3.11507 10.9814ZM3.55859 10.9814L3.55859 11.3314C3.75189 11.3314 3.90859 11.1747 3.90859 10.9814L3.55859 10.9814ZM3.55859 10.3498L3.90859 10.3498C3.90859 10.1565 3.75189 9.9998 3.55859 9.9998L3.55859 10.3498ZM1.99266 9.80017C2.37402 9.80017 2.70228 9.88986 2.92343 10.017C3.15395 10.1495 3.2075 10.2806 3.20787 10.3516L3.90786 10.348C3.90567 9.92193 3.60805 9.60315 3.27232 9.41014C2.92723 9.21174 2.47416 9.10017 1.99266 9.10017L1.99266 9.80017ZM0.777461 10.3525C0.777461 10.2816 0.830242 10.1505 1.06071 10.0177C1.28185 9.89019 1.61058 9.80017 1.99266 9.80017L1.99266 9.10017C1.51031 9.10017 1.05644 9.21214 0.711089 9.41124C0.375062 9.60497 0.0774607 9.92511 0.0774607 10.3525L0.777461 10.3525ZM0.777707 10.362C0.777544 10.3588 0.777461 10.3557 0.777461 10.3525L0.0774607 10.3525C0.0774607 10.3679 0.0778637 10.3833 0.0786643 10.3986L0.777707 10.362ZM0.778186 10.9814L0.778186 10.3803L0.0781858 10.3803L0.0781858 10.9814L0.778186 10.9814ZM0.870261 10.6314L0.428186 10.6314L0.428186 11.3314L0.870261 11.3314L0.870261 10.6314ZM1.99266 10.9049C1.60324 10.9049 1.26967 10.8114 1.04879 10.6804L0.691728 11.2825C1.03963 11.4888 1.50162 11.6049 1.99266 11.6049L1.99266 10.9049ZM2.93654 10.6804C2.71566 10.8114 2.38208 10.9049 1.99266 10.9049L1.99266 11.6049C2.4837 11.6049 2.94569 11.4888 3.2936 11.2825L2.93654 10.6804ZM3.55859 10.6314L3.11507 10.6314L3.11507 11.3314L3.55859 11.3314L3.55859 10.6314ZM3.20859 10.3498L3.20859 10.9814L3.90859 10.9814L3.90859 10.3498L3.20859 10.3498ZM3.55786 10.6998L3.55859 10.6998L3.55859 9.9998L3.55786 9.9998L3.55786 10.6998Z"
      fill="#212121"
    />
    <ellipse
      cx="1.99099"
      cy="11.0088"
      rx="0.902356"
      ry="1.5652"
      transform="rotate(-90 1.99099 11.0088)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M1.60156 12.2783L2.38416 12.2783L2.38416 11.2632C2.38416 11.1386 2.20897 11.0376 1.99286 11.0376C1.77675 11.0376 1.60156 11.1386 1.60156 11.2632L1.60156 12.2783Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="1.99286"
      cy="12.2754"
      rx="0.225589"
      ry="0.391301"
      transform="rotate(-90 1.99286 12.2754)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M10.4688 1.73926L11.2514 1.73926L11.2514 0.724107C11.2514 0.599517 11.0762 0.498518 10.8601 0.498518C10.6439 0.498518 10.4688 0.599517 10.4688 0.724107L10.4688 1.73926Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="10.8601"
      cy="1.73632"
      rx="0.225589"
      ry="0.391301"
      transform="rotate(-90 10.8601 1.73632)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.425 2.18573C12.4224 1.68863 11.7227 1.28611 10.8598 1.28611C9.99536 1.28611 9.29459 1.69011 9.29459 2.18846C9.29459 2.1981 9.29485 2.2077 9.29537 2.21726L9.29537 2.81738L9.73739 2.81738C10.0218 2.98604 10.4196 3.09082 10.8598 3.09082C11.3 3.09082 11.6978 2.98604 11.9822 2.81738L12.4258 2.81738L12.4258 2.18573L12.425 2.18573Z"
      fill="white"
    />
    <path
      d="M10.8598 1.28611L10.8598 1.63611L10.8598 1.28611ZM12.425 2.18573L12.075 2.18753C12.076 2.38013 12.2324 2.53573 12.425 2.53573L12.425 2.18573ZM9.29537 2.21726L9.64537 2.21726C9.64537 2.21092 9.6452 2.20458 9.64486 2.19825L9.29537 2.21726ZM9.29537 2.81738L8.94537 2.81738C8.94537 2.91021 8.98225 2.99923 9.04789 3.06487C9.11352 3.13051 9.20255 3.16738 9.29537 3.16738L9.29537 2.81738ZM9.73739 2.81738L9.91592 2.51634C9.86189 2.48429 9.80022 2.46738 9.73739 2.46738L9.73739 2.81738ZM11.9822 2.81738L11.9822 2.46738C11.9194 2.46738 11.8577 2.48429 11.8037 2.51634L11.9822 2.81738ZM12.4258 2.81738L12.4258 3.16738C12.6191 3.16738 12.7758 3.01068 12.7758 2.81738L12.4258 2.81738ZM12.4258 2.18573L12.7758 2.18573C12.7758 1.99243 12.6191 1.83573 12.4258 1.83573L12.4258 2.18573ZM10.8598 1.63611C11.2412 1.63611 11.5694 1.72579 11.7906 1.85294C12.0211 1.98546 12.0746 2.1165 12.075 2.18753L12.775 2.18393C12.7728 1.75786 12.4752 1.43909 12.1395 1.24608C11.7944 1.04768 11.3413 0.936108 10.8598 0.936108L10.8598 1.63611ZM9.64459 2.18846C9.64459 2.11752 9.69737 1.98649 9.92784 1.85362C10.149 1.72613 10.4777 1.63611 10.8598 1.63611L10.8598 0.936108C10.3774 0.936107 9.92357 1.04808 9.57822 1.24718C9.24219 1.44091 8.94459 1.76105 8.94459 2.18846L9.64459 2.18846ZM9.64486 2.19825C9.64468 2.19502 9.64459 2.19175 9.64459 2.18846L8.94459 2.18846C8.94459 2.20444 8.94503 2.22038 8.94589 2.23626L9.64486 2.19825ZM9.64537 2.81738L9.64537 2.21726L8.94537 2.21726L8.94537 2.81738L9.64537 2.81738ZM9.73739 2.46738L9.29537 2.46738L9.29537 3.16738L9.73739 3.16738L9.73739 2.46738ZM10.8598 2.74082C10.4704 2.74082 10.1368 2.64733 9.91592 2.51634L9.55886 3.11842C9.90677 3.32475 10.3688 3.44082 10.8598 3.44082L10.8598 2.74082ZM11.8037 2.51634C11.5828 2.64733 11.2492 2.74082 10.8598 2.74082L10.8598 3.44082C11.3508 3.44082 11.8128 3.32475 12.1607 3.11842L11.8037 2.51634ZM12.4258 2.46738L11.9822 2.46738L11.9822 3.16738L12.4258 3.16738L12.4258 2.46738ZM12.0758 2.18573L12.0758 2.81738L12.7758 2.81738L12.7758 2.18573L12.0758 2.18573ZM12.425 2.53573L12.4258 2.53573L12.4258 1.83573L12.425 1.83573L12.425 2.53573Z"
      fill="#212121"
    />
    <ellipse
      cx="10.8582"
      cy="2.84081"
      rx="0.902356"
      ry="1.5652"
      transform="rotate(-90 10.8582 2.84081)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M9.49219 10.333L12.2313 10.333L12.2313 2.63478C12.2313 2.19872 11.6181 1.84522 10.8617 1.84522C10.1054 1.84522 9.49219 2.19871 9.49219 2.63478L9.49219 10.333Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="10.8617"
      cy="10.3286"
      rx="0.789562"
      ry="1.36955"
      transform="rotate(-90 10.8617 10.3286)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.425 10.3498C12.4224 9.85269 11.7226 9.45017 10.8598 9.45017C9.99535 9.45017 9.29458 9.85417 9.29458 10.3525C9.29458 10.3622 9.29485 10.3719 9.29537 10.3815L9.29537 10.9814L9.73738 10.9814C10.0218 11.1501 10.4196 11.2549 10.8598 11.2549C11.3 11.2549 11.6978 11.1501 11.9822 10.9814L12.4258 10.9814L12.4258 10.3498L12.425 10.3498Z"
      fill="white"
    />
    <path
      d="M10.8598 9.45017L10.8598 9.80017L10.8598 9.45017ZM12.425 10.3498L12.075 10.3516C12.076 10.5442 12.2324 10.6998 12.425 10.6998L12.425 10.3498ZM9.29537 10.3815L9.64537 10.3815C9.64537 10.3751 9.6452 10.3687 9.64485 10.3624L9.29537 10.3815ZM9.29537 10.9814L8.94537 10.9814C8.94537 11.0743 8.98225 11.1633 9.04789 11.2289C9.11352 11.2946 9.20255 11.3314 9.29537 11.3314L9.29537 10.9814ZM9.73738 10.9814L9.91592 10.6804C9.86188 10.6484 9.80021 10.6314 9.73738 10.6314L9.73738 10.9814ZM11.9822 10.9814L11.9822 10.6314C11.9194 10.6314 11.8577 10.6484 11.8037 10.6804L11.9822 10.9814ZM12.4258 10.9814L12.4258 11.3314C12.6191 11.3314 12.7758 11.1747 12.7758 10.9814L12.4258 10.9814ZM12.4258 10.3498L12.7758 10.3498C12.7758 10.1565 12.6191 9.9998 12.4258 9.9998L12.4258 10.3498ZM10.8598 9.80017C11.2411 9.80017 11.5694 9.88986 11.7906 10.017C12.0211 10.1495 12.0746 10.2806 12.075 10.3516L12.775 10.348C12.7728 9.92193 12.4752 9.60315 12.1394 9.41014C11.7944 9.21174 11.3413 9.10017 10.8598 9.10017L10.8598 9.80017ZM9.64458 10.3525C9.64458 10.2816 9.69736 10.1505 9.92783 10.0177C10.149 9.89019 10.4777 9.80017 10.8598 9.80017L10.8598 9.10017C10.3774 9.10017 9.92357 9.21214 9.57821 9.41124C9.24218 9.60497 8.94458 9.92511 8.94458 10.3525L9.64458 10.3525ZM9.64485 10.3624C9.64467 10.3591 9.64458 10.3558 9.64458 10.3525L8.94458 10.3525C8.94458 10.3686 8.94502 10.3846 8.94589 10.4006L9.64485 10.3624ZM9.64537 10.9814L9.64537 10.3815L8.94537 10.3815L8.94537 10.9814L9.64537 10.9814ZM9.73738 10.6314L9.29537 10.6314L9.29537 11.3314L9.73738 11.3314L9.73738 10.6314ZM10.8598 10.9049C10.4704 10.9049 10.1368 10.8114 9.91592 10.6804L9.55885 11.2825C9.90676 11.4888 10.3687 11.6049 10.8598 11.6049L10.8598 10.9049ZM11.8037 10.6804C11.5828 10.8114 11.2492 10.9049 10.8598 10.9049L10.8598 11.6049C11.3508 11.6049 11.8128 11.4888 12.1607 11.2825L11.8037 10.6804ZM12.4258 10.6314L11.9822 10.6314L11.9822 11.3314L12.4258 11.3314L12.4258 10.6314ZM12.0758 10.3498L12.0758 10.9814L12.7758 10.9814L12.7758 10.3498L12.0758 10.3498ZM12.425 10.6998L12.4258 10.6998L12.4258 9.9998L12.425 9.9998L12.425 10.6998Z"
      fill="#212121"
    />
    <ellipse
      cx="10.8582"
      cy="11.0088"
      rx="0.902356"
      ry="1.5652"
      transform="rotate(-90 10.8582 11.0088)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <path
      d="M10.4688 12.2783L11.2514 12.2783L11.2514 11.2632C11.2514 11.1386 11.0762 11.0376 10.8601 11.0376C10.6439 11.0376 10.4688 11.1386 10.4688 11.2632L10.4688 12.2783Z"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
    <ellipse
      cx="10.8601"
      cy="12.2754"
      rx="0.225589"
      ry="0.391301"
      transform="rotate(-90 10.8601 12.2754)"
      fill="white"
      stroke="#212121"
      strokeWidth="0.7"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArticlesIcon;
